<template>
    <div class="container">
      <!-- 投保规则 -->
      <div v-if="p !== 'BOCI19'">
        <h4>{{ $t("insureText.tbgz.title") }}</h4>
        <p class="pre_" v-html="$t('insureText.tbgz.' + p)"></p>
      </div>
      <!-- 投保须知 -->
      <h4>{{ $t("insureText.tbxz.title") }}</h4>
      <p class="pre_" v-html="$t('insureText.tbxz.' + p)"></p>
    </div>
</template>
<script>
export default {
    data() {
      return {
        p: ''
      }
    },
    computed: {
      lang() {
        return this.$i18n.locale == 'zh-cn' ? 1 : 2
      }
    },
    mounted() {
      this.p = this.$route.query.p
    }
}
</script>

<style lang="scss" scoped>
.container{
  line-height: 1.8;
}
::v-deep .highlight_ {
    color: #FF3E18;
    font-weight: bold;
}
</style>
